/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmParametrGlobal extends GContentBase<SeznamAdmParametrGlobalObj> {
        private seznamObj: SeznamAdmParametrGlobalObj & GContent;

        createListOfColumns(): string {
            if (this.uroven_cfg == 10)
                return "param,param_txt,config_txt,dat_zmena,zmenu_prov_txt"
            else
                return "subj_cfg_txt,param,param_txt,config_txt,dat_zmena,zmenu_prov_txt"
        }

        private getContentCaption(): string {
            switch (this.uroven_cfg) {
                case 20:
                    return "jres:33000306"; //RC 33000306 : Parametry pro I�O
                case 30:
                    return "jres:33000309"; //RC 33000309 : Parametry pro licence
                case 35:
                    return "jres:33000310"; //RC 33000310 : Parametry pro st�ediska
                case 38:
                    return "jres:33000311" //RC 33000311 : Parametry pro f�ze
                case 40:
                    return "jres:33000302"; //RC 33000302 : Parametry pro instance
                case 60:
                    return "jres:33000304"; //RC 33000304 : Parametry pro funkce
                case 70:
                    return "jres:33000314"; //RC 33000314 : Parametry pro extern� syst�my
                default:
                    return "jres:33000287"; //RC 33000287 : Glob�ln� parametry
            }
        }

        onContentReady() {
            this.element.addHelpContext("level:" + Gordic.Adm.WebControls.FunctionsAdmParametrGlobal.createContenxtHelpString(this.uroven_cfg))
            this.seznamObj = $.extend(this as GContent, new SeznamAdmParametrGlobalObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmParametrGlobal",
                contentCaption: this.getContentCaption(),
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{param}"
                },
                gridSettings: {
                    columnOrder: this.createListOfColumns()
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmParametrGlobalObj extends GAdmSeznamBase {
        uroven_cfg: number;
        faze: string;
        ixs_ins: string;
        ixs_fun: string;

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            const cntInitializer = ["Gordic.Adm.WebControls.DetailAdmParametrGlobal", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid),
                openDialog: this.tabOpen
            }];
            const inputParams = {
                ID: "DetailAdmParametrGlobal",
                newRecord: isNew,
                param: isNew == true ? null : data.param,
                subj_cfg: isNew == true ? this.getSubjCfg() : data.subj_cfg,
                uroven_cfg: this.uroven_cfg,
                allowCopy: (this.faze || this.ixs_ins) ? false : true
            }
            this.openDialogOrModalWindow(cntInitializer, inputParams);
        }

        private getSubjCfg() {
            if (this.faze)
                return this.faze;
            else if (this.ixs_ins)
                return this.ixs_ins;
            else if (this.ixs_fun)
                return this.ixs_fun;
            else
                return null;
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actCopy: {
                    caption: "jres:33000669", //RC 33000669 : Kopie
                    icon: "gi-copy",
                    enabled: this.uroven_cfg != 10 && this.uroven_cfg != 20 && this.getSubjCfg() == null,
                    run: (ev, ctx) => {
                        this.copyParam();
                    }
                }
            }
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actCopy*", "actAddToComparison*"]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*", "actCopy*"])
        }

        createFilterForm() { 
            switch (this.uroven_cfg) {
                case 38:
                    this.filterForm.addRow("jres:33000698").addField("gselectbox", Gordic.Prefabs.Select.gincfaz(), { //RC 33000698 : F�ze
                        name: "subj_cfg",
                        model: "model.subj_cfg=value.faze",
                        dropdown: true,
                        disabled: this.faze ? true : false
                    })
                    break;
                case 40:
                    this.filterForm.addRow("jres:29802565").addField("gselectbox", Gordic.Prefabs.Select.ginsins(), {
                        name: "subj_cfg",
                        model: "model.subj_cfg=value.ixs_ins",
                        dropdown: true,
                        disabled: this.ixs_ins ? true : false
                    })
                    break;
                case 60:
                    this.filterForm.addRow("jres:32131054").addField("gselectbox", Gordic.Prefabs.Select.ginsfun(), {
                        name: "subj_cfg",
                        model: "model.subj_cfg=value.ixs_fun",
                        dropdown: true,
                        disabled: this.ixs_fun ? true : false
                    })
                    break;
            }
        }

        userhardDefaultFilter(hardFilter: any): any {
            if (this.faze)
                hardFilter.subj_cfg = this.faze;
            else if (this.ixs_ins)
                hardFilter.subj_cfg = this.ixs_ins
            else if (this.ixs_fun)
                hardFilter.subj_cfg = this.ixs_fun
            return hardFilter;
        }

        collectData(data: any) {
            if (this.uroven_cfg)
                data.uroven_cfg = this.uroven_cfg;
            if (this.faze)
                data.subj_cfg = this.faze;
            else if (this.ixs_ins)
                data.subj_cfg = this.ixs_ins
            else if (this.ixs_fun)
                data.subj_cfg = this.ixs_fun
        }

        applydata(filterData: any) {
            this.cnt.isl.AdmParametrGlobal.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {
            this.cnt.actions.actCopy?.update({ enabled: objArr.count > 0 && this.getSubjCfg() == null })
        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}#{1}#{2}#".format(data.uroven_cfg, data.param, data.subj_cfg),
                nazev: ""
            }
        }

        private copyParam() {
            var activeRow = this.grid.ggrid("activeRow")
            if (activeRow != null) {
                $.content().navigate(["Gordic.Adm.WebControls.DetailAdmParametrGlobal", {
                    currentFilter: this.filterData,
                    gridRc: new Gordic.Components.GridRC(this.grid)
                }], {
                    ID: "DetailAdmParametrGlobal",
                    newRecord: false,
                    copy: true,
                    param: activeRow.param,
                    subj_cfg: activeRow.subj_cfg,
                    uroven_cfg: this.uroven_cfg,
                })
            }
        }
    }
}